export const formatBarLabels = (datum: { y: number }, total: number): string =>
  `${Math.round((datum.y * 100) / total)}%`;

export const labelFormatter = (x?: string): string => (x && x.length > 35 ? x.substr(0, 35) + '...' : (x as any));
